import libphonenumber from 'google-libphonenumber'

const PNF = libphonenumber.PhoneNumberFormat
const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance()

const obfuscatePart = (part: string) => {
  return `${part[0]}••`
}

const obfuscatePhoneNumber = (phoneNumber: string) => {
  try {
    // User supplied country code (+1)
    const parsedPhone = phoneUtil.parse(phoneNumber)
    let formattedPhone = phoneUtil.format(parsedPhone, PNF.INTERNATIONAL) // Format: +1 202-456-1414
    formattedPhone = formattedPhone.toString().replace(' ', '-').replace('+', '') // Format: 1-202-456-1414
    const parts = formattedPhone.split('-')
    return `${parts[0]}-${obfuscatePart(parts[1])}-•••-${parts[3]}` // Format: 1-2••-•••-••••
  } catch (e) {
    // User did not supply country code
    // If there is no country code, format as xxx-xxx-xxxx
    if ((e as { message: string }).message.includes('Invalid country calling code')) {
      try {
        const parsedPhone = phoneUtil.parse(phoneNumber, 'US')
        let formattedPhone = phoneUtil.format(parsedPhone, PNF.INTERNATIONAL) // Format: +1 202-456-1414
        formattedPhone = formattedPhone.toString().replace(' ', '-').replace('+1-', '') // Format: 202-456-1414
        const parts = formattedPhone.split('-')
        return `${obfuscatePart(parts[0])}-•••-${parts[2]}` // Format: 1-2••-•••-••••
      } catch {
        //
      }
    }
    return phoneNumber
  }
}

const obfuscateEmail = (email: string) => {
  const [localPart, domain] = email.split('@')
  if (localPart.length <= 2) {
    return `${localPart}••••@${domain}`
  }
  return `${localPart.slice(0, 2)}••••@${domain}`
}

const obfuscate = (input: string) => {
  if (input.includes('@')) {
    return obfuscateEmail(input)
  }
  return obfuscatePhoneNumber(input)
}

export default obfuscate
